import { i18n } from '@/plugins/i18n'

export const gatewayStatus = {
    ACTIVE: 1,
    PENDING: 2,
    REJECTED: 3,
    BLOCKED: 4,
    HAS: 5,
    DOES_NOT_HAVE: 6,
    SEND_TO_SHAPARAK: 9,
    REJECTED_BY_SHAPARAK: 10,
    ENAMAD_PENDING: 12,
    ENAMAD_AUTHENTICATED: 13,
    AWAITING_CONTRACT: 14,
}

export const gatewayStatusStr = {
    ACTIVE: i18n.t('gateway_status.active'),
    PENDING: i18n.t('gateway_status.pending'),
    REJECTED: i18n.t('gateway_status.rejected'),
    BLOCKED: i18n.t('gateway_status.blocked'),
    HAS: i18n.t('gateway_status.has'),
    REJECTED_BY_SHAPARAK: i18n.t('gateway_status.rejected_by_shaparak'),
    DOES_NOT_HAVE: i18n.t('gateway_status.does_not_have'),
    SEND_TO_SHAPARAK: i18n.t('gateway_status.send_to_shaparak'),
    ENAMAD_PENDING: i18n.t('gateway_status.enamad_pending'),
    ENAMAD_AUTHENTICATED: i18n.t('gateway_status.enamad_authenticated'),
    AWAITING_CONTRACT: i18n.t('gateway_status.awaiting_contract'),
    get(status) {
        let status_str = null;
        Object.keys(gatewayStatus).forEach(function (item) {
            if(gatewayStatus[item] === status) {
                status_str = gatewayStatusStr[item]
            }
        })

        return status_str
    }
}

export const gatewayVariant = (status) => {
    if(status === gatewayStatus.ACTIVE || status === gatewayStatus.HAS) {
        return 'success'
    }

    if(status === gatewayStatus.DOES_NOT_HAVE 
        || status === gatewayStatus.REJECTED
        || status === gatewayStatus.BLOCKED
        || status === gatewayStatus.REJECTED_BY_SHAPARAK
    ) {
        return 'danger'
    }

    if(status === gatewayStatus.PENDING
        || status === gatewayStatus.SEND_TO_SHAPARAK
        || status === gatewayStatus.ENAMAD_PENDING
        || status === gatewayStatus.AWAITING_CONTRACT
    ) {
        return 'warning'
    }

    return 'info'
} 